import { render, staticRenderFns } from "./CollectionsCarouselList.vue?vue&type=template&id=cef68aac"
import script from "./CollectionsCarouselList.vue?vue&type=script&lang=js"
export * from "./CollectionsCarouselList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports